(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mz-device-finder"] && !Shopify.designMode) return;
  try {
    (() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  const syncVisibility = () => instances.forEach((state, section) => section.toggleAttribute('data-hidden', document.hidden));
  const syncMotion = () => instances.forEach(state => {
    state.toggle.hidden = motion.matches;
    if (motion.matches) state.entrances.forEach(animation => animation.cancel());
  });
  const init = (scope = document) => {
    scope.querySelectorAll('[data-mz-finder]').forEach(section => {
      if (instances.has(section)) return;
      const toggle = section.querySelector('[data-mz-finder-toggle]');
      const abort = new AbortController();
      const entrances = [];
      let entered = false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          section.toggleAttribute('data-visible', entry.isIntersecting);
          if (entry.isIntersecting && !entered) {
            entered = true;
            if (!motion.matches && !section.hasAttribute('data-paused') && !section.contains(document.activeElement)) {
              section.querySelectorAll('[data-mz-finder-panel]').forEach((panel, index) => entrances.push(panel.animate([
                { opacity: .4, transform: 'translateY(24px)' },
                { opacity: 1, transform: 'translateY(0)' }
              ], { duration: 750, delay: index * 120, easing: 'cubic-bezier(.2,.75,.3,1)' })));
            }
          }
        });
      }, { threshold: .04 });
      observer.observe(section);
      toggle.addEventListener('click', () => {
        const paused = section.toggleAttribute('data-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.querySelector('span').textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        toggle.querySelector('path').setAttribute('d', paused ? 'M6 4l9 6-9 6Z' : 'M7 5v10M13 5v10');
        if (paused) entrances.forEach(animation => animation.cancel());
      }, { signal: abort.signal });
      section.addEventListener('focusin', () => entrances.forEach(animation => animation.cancel()), { signal: abort.signal });
      section.setAttribute('data-ready', '');
      toggle.hidden = motion.matches;
      instances.set(section, { observer, abort, entrances, toggle });
    });
    syncVisibility();
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => instances.forEach((state, section) => {
    if (!event.target.contains(section)) return;
    state.observer.disconnect();
    state.abort.abort();
    state.entrances.forEach(animation => animation.cancel());
    instances.delete(section);
  }));
  document.addEventListener('visibilitychange', syncVisibility);
  motion.addEventListener('change', syncMotion);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-exchange-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-mz-exchange-form]').forEach(root => {
      if (initialized.has(root)) return;
      const device = root.querySelector('[data-exchange-device-type]');
      const otherField = root.querySelector('[data-exchange-other-field]');
      const otherInput = root.querySelector('[data-exchange-other-input]');
      if (!device || !otherField || !otherInput) return;
      const syncOther = () => {
        const selected = device.value === 'Other';
        otherField.hidden = !selected;
        otherInput.disabled = !selected;
        otherInput.required = selected;
        otherField.querySelector('[data-exchange-other-required]').hidden = !selected;
      };
      device.addEventListener('change', syncOther);
      device.form.addEventListener('reset', () => requestAnimationFrame(syncOther));
      syncOther();
      initialized.add(root);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-home-videos"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new Map();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const init = (scope = document) => scope.querySelectorAll('[data-mz-home-videos]').forEach(root => {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-mzvs-track]');
    const slides = [...root.querySelectorAll('[data-mzvs-slide]')];
    const videos = slides.map(slide => slide.querySelector('video'));
    const soundButtons = [...root.querySelectorAll('[data-mzvs-sound]')];
    const dots = [...root.querySelectorAll('[data-mzvs-dot]')];
    const previous = root.querySelector('[data-mzvs-prev]');
    const next = root.querySelector('[data-mzvs-next]');
    const status = root.querySelector('[data-mzvs-status]');
    const abort = new AbortController();
    const states = videos.map(() => ({ userPaused:false, systemPause:false, automatic:false }));
    let index = 2, visible = false, loadedPosters = false, settleTimer = 0, resizeFrame = 0, visibilityFrame = 0;
    const listen = (target, name, callback, options = {}) => target.addEventListener(name, callback, { ...options, signal:abort.signal });
    const audible = video => !video.muted && video.volume > 0;
    const syncSound = i => {
      const on = audible(videos[i]);
      const button = soundButtons[i];
      button.setAttribute('aria-pressed',String(on));
      button.querySelector('span').textContent = on && !videos[i].paused ? button.dataset.muteLabel : button.dataset.playLabel;
      button.querySelector('[data-mzvs-sound-icon]').setAttribute('d', on ? 'M4 9h4l5-4v14l-5-4H4V9Zm12-1a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14' : 'M4 9h4l5-4v14l-5-4H4V9Zm13 0 5 6m0-6-5 6');
    };
    const stop = i => {
      const video = videos[i];
      if (!video.paused) { states[i].systemPause = true; video.pause(); }
      video.muted = true;
      states[i].automatic = false;
      syncSound(i);
    };
    const stopOthers = keep => videos.forEach((video,i) => { if (i !== keep) stop(i); });
    const paint = () => {
      slides.forEach((slide,i) => slide.classList.toggle('is-active',i === index));
      dots.forEach((dot,i) => dot.setAttribute('aria-current',String(i === index)));
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      status.textContent = root.dataset.positionLabel.replace('[number]',String(index + 1));
    };
    const safePlay = video => {
      try { const result = video.play(); if (result?.catch) result.catch(() => {}); } catch (error) {}
    };
    const autoplay = () => {
      const video = videos[index];
      if (!visible || document.hidden || motion.matches || states[index].userPaused || !video.paused) return;
      stopOthers(index);
      video.preload = 'metadata';
      video.muted = true;
      states[index].automatic = true;
      safePlay(video);
    };
    const select = (target, auto = true) => {
      const changed = index !== target;
      index = Math.max(0,Math.min(slides.length - 1,target));
      stopOthers(index);
      paint();
      if (auto && changed) autoplay();
    };
    const center = (target, smooth = true) => {
      const slide = slides[target];
      track.scrollTo({ left:slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2, behavior:smooth && !motion.matches ? 'smooth' : 'instant' });
    };
    const go = target => {
      select(Math.max(0,Math.min(slides.length - 1,target)),false);
      center(index);
    };
    const syncVisibility = () => {
      if (!visible || document.hidden) videos.forEach((video,i) => stop(i));
      else if (motion.matches) states.forEach((state,i) => { if (state.automatic) stop(i); });
      else autoplay();
    };
    const measureVisibility = (applyPlayback = true) => {
      const rect = track.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      visible = rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < viewportWidth && rect.bottom > 0 && rect.top < viewportHeight;
      if (visible && !loadedPosters) {
        videos.forEach(video => { if (!video.poster && video.dataset.poster) video.poster = video.dataset.poster; });
        loadedPosters = true;
      }
      if (applyPlayback) syncVisibility();
    };
    const scheduleVisibility = () => {
      if (!visibilityFrame) visibilityFrame = requestAnimationFrame(() => { visibilityFrame = 0; measureVisibility(); });
    };
    soundButtons.forEach((button,i) => {
      button.hidden = false;
      listen(button,'click',() => {
        measureVisibility(false);
        const video = videos[i];
        if (audible(video) && !video.paused) video.muted = true;
        else {
          select(i,false); center(i,false); stopOthers(i);
          states[i].userPaused = false; states[i].automatic = false;
          video.preload = 'metadata'; video.muted = false; video.volume = 1;
          safePlay(video);
        }
        syncSound(i);
      });
      listen(videos[i],'play',() => {
        if (videos[i].paused) { syncSound(i); return; }
        if (!visible || document.hidden) { stop(i); return; }
        if (index !== i) { select(i,false); center(i,false); }
        stopOthers(i); states[i].userPaused = false; syncSound(i);
      });
      listen(videos[i],'pause',() => {
        if (states[i].systemPause) states[i].systemPause = false;
        else { states[i].userPaused = true; states[i].automatic = false; }
        syncSound(i);
      });
      listen(videos[i],'volumechange',() => {
        if (audible(videos[i])) { states[i].automatic = false; if (!videos[i].paused) stopOthers(i); }
        syncSound(i);
      });
      listen(videos[i],'ended',() => syncSound(i));
      syncSound(i);
    });
    listen(previous,'click',() => go(index - 1));
    listen(next,'click',() => go(index + 1));
    dots.forEach((dot,i) => listen(dot,'click',() => go(i)));
    listen(track,'keydown',event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    listen(track,'scroll',() => {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => {
        const middle = track.scrollLeft + track.clientWidth / 2;
        let closest = index;
        slides.forEach((slide,i) => { if (Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - middle) < Math.abs(slides[closest].offsetLeft + slides[closest].offsetWidth / 2 - middle)) closest = i; });
        select(closest);
        autoplay();
      },140);
    },{passive:true});
    const observer = new IntersectionObserver(() => measureVisibility(),{threshold:[0,.15]});
    observer.observe(track);
    const resize = new ResizeObserver(() => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => { center(index,false); measureVisibility(); });
    });
    resize.observe(track);
    listen(window,'scroll',scheduleVisibility,{passive:true,capture:true});
    listen(window,'resize',scheduleVisibility,{passive:true});
    listen(document,'visibilitychange',() => measureVisibility());
    listen(motion,'change',() => measureVisibility());
    root.querySelector('[data-mzvs-controls]').hidden = false;
    paint();
    resizeFrame = requestAnimationFrame(() => { center(2,false); measureVisibility(); });
    instances.set(root,() => {
      abort.abort(); observer.disconnect(); resize.disconnect(); clearTimeout(settleTimer); cancelAnimationFrame(resizeFrame); cancelAnimationFrame(visibilityFrame);
      videos.forEach(video => { video.muted = true; video.pause(); });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(),{once:true}); else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => instances.forEach((cleanup,root) => {
    if (event.target === root || event.target.contains(root)) { cleanup(); instances.delete(root); }
  }));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-lease-birth-date"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  const normalize = value => {
    const raw = value.trim();
    if (/^\d{8}$/.test(raw)) return `${raw.slice(0,2)}/${raw.slice(2,4)}/${raw.slice(4)}`;
    const parts = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    return parts ? `${parts[1].padStart(2,'0')}/${parts[2].padStart(2,'0')}/${parts[3]}` : raw;
  };
  const validDate = value => {
    const parts = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!parts) return false;
    const month = Number(parts[1]), day = Number(parts[2]), year = Number(parts[3]);
    const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const days = [31,leap ? 29 : 28,31,30,31,30,31,31,30,31,30,31];
    return year > 0 && month >= 1 && month <= 12 && day >= 1 && day <= days[month - 1];
  };
  const init = (root = document) => root.querySelectorAll('[data-mz-lease-birth-date]').forEach(input => {
    if (initialized.has(input)) return;
    const sync = () => {
      const value = normalize(input.value);
      if (input.value !== value) input.value = value;
      input.setCustomValidity(!value || validDate(value) ? '' : input.dataset.dateError);
    };
    input.addEventListener('input',sync);
    input.addEventListener('blur',sync);
    input.form?.addEventListener('reset',() => requestAnimationFrame(sync));
    initialized.add(input);
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(),{once:true});
  else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-lease-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mz-lease-consent')) {
  customElements.define('mz-lease-consent', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.dialog = this.querySelector('dialog');
      if (!this.form || !this.dialog) return;
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.allowed = false;
      this.valueInput = this.querySelector('[data-lease-consent-value]');
      this.valueInput.disabled = false;
      this.status = this.querySelector('[data-lease-consent-status]');
      this.agree = this.querySelector('[data-lease-agree]');
      this.form.addEventListener('submit', event => {
        if (this.allowed) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.valueInput.value = '';
        if (!this.form.reportValidity()) return;
        this.submitter = event.submitter;
        this.status.textContent = '';
        if (!this.dialog.open) this.dialog.showModal();
      }, { ...options, capture: true });
      this.agree.addEventListener('click', () => {
        if (this.agree.disabled) return;
        this.dialog.close();
        if (!this.form.reportValidity()) return;
        this.valueInput.value = this.querySelector('[data-lease-consent-record]').textContent.trim();
        this.allowed = true;
        this.agree.disabled = true;
        try {
          if (this.submitter?.form === this.form) this.form.requestSubmit(this.submitter);
          else this.form.requestSubmit();
        } finally {
          this.allowed = false;
          this.agree.disabled = false;
        }
      }, options);
      const returnToApplication = () => {
        this.valueInput.value = '';
        this.allowed = false;
        this.dialog.close();
        this.status.textContent = this.querySelector('[data-lease-consent-return]').textContent.trim();
        const heading = this.form.parentElement.querySelector('.mz-lease-form-heading');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.scrollIntoView({ block: 'start', behavior: 'instant' });
          heading.focus({ preventScroll: true });
        } else this.submitter?.focus();
      };
      this.querySelector('[data-lease-disagree]').addEventListener('click', returnToApplication, options);
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        returnToApplication();
      }, options);
    }
    disconnectedCallback() {
      this.events?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-lease-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('[data-lease-premium]').forEach(root => {
    if (root.dataset.leaseReady) return;
    root.dataset.leaseReady = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const chapters = [...root.querySelectorAll('[data-lease-chapter]')];
    const links = [...root.querySelectorAll('[data-lease-nav]')];
    const animations = new Set();
    const hero = root.querySelector('.mz-lease-hero');
    let frame = 0;
    let visible = true;
    const play = (el, delay = 0) => {
      if (reduced.matches || !el.animate) return;
      const animation = el.animate([
        { opacity: .25, transform: 'translateY(42px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 850, delay, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
    };
    const update = () => {
      frame = 0;
      if (!root.isConnected || !visible) return;
      const rect = root.getBoundingClientRect();
      const heroRect = hero.getBoundingClientRect();
      const chapterRects = chapters.map(chapter => chapter.getBoundingClientRect());
      const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height - innerHeight)));
      const distance = Math.max(0, -rect.top);
      const heroProgress = Math.max(0, Math.min(1, -heroRect.top / Math.max(1, heroRect.height)));
      let current = chapters[0];
      chapterRects.forEach((chapterRect, index) => { if (chapterRect.top < innerHeight * .42) current = chapters[index]; });
      root.style.setProperty('--lease-scroll', progress.toFixed(4));
      if (!reduced.matches) {
        root.style.setProperty('--lease-drift-x', (Math.sin(distance / 580) * 145).toFixed(1) + 'px');
        root.style.setProperty('--lease-drift-y', (Math.sin(distance / 760) * 100).toFixed(1) + 'px');
        root.style.setProperty('--lease-angle', (distance * .035).toFixed(1) + 'deg');
        hero.style.setProperty('--hero-progress', heroProgress.toFixed(4));
        chapters.forEach((chapter, index) => {
          const bounds = chapterRects[index];
          if (bounds.bottom < 0 || bounds.top > innerHeight) return;
          chapter.style.setProperty('--chapter-progress', Math.max(0, Math.min(1, (innerHeight - bounds.top) / (innerHeight + bounds.height))).toFixed(4));
        });
      }
      links.forEach(link => {
        if (current && link.dataset.leaseNav === current.dataset.leaseChapter) link.setAttribute('aria-current', 'step');
        else link.removeAttribute('aria-current');
      });
    };
    const schedule = () => { if (!frame && visible) frame = requestAnimationFrame(update); };
    if ('IntersectionObserver' in window) {
      const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        play(entry.target);
        entry.target.dataset.leaseRevealed = 'true';
        reveal.unobserve(entry.target);
      }), { threshold: .08, rootMargin: '0px 0px -24px 0px' });
      root.querySelectorAll('[data-lease-reveal]').forEach(el => reveal.observe(el));
      const visibility = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) schedule();
      });
      visibility.observe(root);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        reveal.disconnect(); visibility.disconnect();
        window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
        cancelAnimationFrame(frame); animations.forEach(animation => animation.cancel());
      });
    }
    root.querySelectorAll('.mz-lease-hero-copy > *').forEach((el, index) => play(el, index * 90));
    root.querySelectorAll('a[href^="#lease-"]').forEach(link => link.addEventListener('click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }));
    reduced.addEventListener('change', () => { animations.forEach(animation => animation.cancel()); schedule(); });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-phone-carrier"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mz-phone-carrier')) {
customElements.define('mz-phone-carrier', class extends HTMLElement {
  connectedCallback() {
    if(this.dataset.directCarrier==='true'){
      this.initDirectCarrier();
      return;
    }
    this.select=this.querySelector('[data-mz-phone-carrier]');
    this.payment=this.querySelector('[data-mz-payment]');
    this.info=this.closest('product-info');
    this.prices=JSON.parse(this.querySelector('[data-carrier-prices]').textContent);
    this.onChange=()=>this.choose();
    this.select.addEventListener('change',this.onChange);
    this.payment?.addEventListener('change',()=>{
      if((this.payment.value||'').toLowerCase().includes('lease')){
        window.location.href='/pages/apply-for-lease';
        return;
      }
      this.onChange();
    });
    this.observer=new MutationObserver(()=>this.sync());
    if(this.info)this.observer.observe(this.info,{childList:true,subtree:true});
    this.sync();
    if(this.dataset.priced==='true' && this.select.options.length>1){
      const productTitle=(this.dataset.productTitle||'').toLowerCase();
      this.select.value=(productTitle.includes('iphone 16 pro')&&!productTitle.includes('pro max'))?'Unlocked':'T-Mobile';
      if(this.payment)this.payment.value='Pay in Full';
      this.choose();
    }
  }
  native(){if(this.dataset.conditionPricing==='true')return null;return this.info?.querySelector('[data-mz-native-purchase]');}
  initDirectCarrier(){
    this.directCarrier=true;
    this.select=this.querySelector('[data-mz-phone-carrier]');
    this.info=this.closest('product-info');
    if(!this.select||!this.info)return;
    try{this.prices=JSON.parse(this.querySelector('[data-carrier-prices]')?.textContent||'{}');}catch{this.prices={};}
    this.onChange=()=>this.chooseDirectCarrier();
    this.select.addEventListener('change',this.onChange);
    this.observer=new MutationObserver(()=>this.syncDirectCarrier());
    this.observer.observe(this.info,{childList:true,subtree:true,characterData:true});
    this.syncDirectCarrier();
  }
  chooseDirectCarrier(){
    const native=this.native();
    if(!native)return;
    const value=this.select.value;
    if(!Array.from(native.options).some(option=>option.value===value)){
      this.syncDirectCarrier();
      return;
    }
    if(native.value===value){this.syncDirectCarrier();return;}
    native.value=value;
    this.setText('[data-carrier-selection]',this.select.selectedOptions[0]?.textContent.trim()||value);
    this.setText('[data-carrier-price]','…');
    // Keep the real carrier option inside variant-selects so Shopify updates
    // the selected variant, image, price, availability and cart variant ID.
    native.dispatchEvent(new Event('change',{bubbles:true}));
  }
  syncDirectCarrier(){
    const native=this.native();
    if(!native)return;
    if(Array.from(this.select.options).some(option=>option.value===native.value))this.select.value=native.value;
    this.setText('[data-carrier-selection]',this.select.selectedOptions[0]?.textContent.trim()||this.select.value);
    const picker=this.info.querySelector('variant-selects');
    let selected=null;
    try{selected=JSON.parse(picker?.querySelector('[data-selected-variant]')?.textContent||'null');}catch{}
    const values=Array.from(picker?.querySelectorAll('.product-form__input')||[]).map(group=>{
      const dropdown=group.querySelector('select');
      return dropdown?dropdown.value:group.querySelector('input:checked')?.value;
    });
    const ready=selected&&values.length===selected.options?.length&&values.every((value,index)=>value===selected.options[index]);
    let price=this.querySelector('[data-unavailable]')?.content.textContent||'Unavailable';
    if(selected)price=ready?(this.prices[String(selected.id)]||''):'…';
    this.setText('[data-carrier-price]',price);
  }
  choose(){
    const native=this.native();
    if(!native){this.sync();return;}
    const carrier=this.select.value;
    if(carrier!=='Unlocked' && this.payment.value!=='Pay in Full')this.payment.value='Pay in Full';
    const mappedCarrier=carrier==='Metro PCS'?'T-Mobile':carrier==='Cricket'?'AT&T':carrier;
    const value=this.payment.value+(carrier==='Unlocked'?'':' · '+mappedCarrier);
    if(!Array.from(native.options).some(o=>o.value===value))return;
    native.value=value;
    this.querySelector('[data-carrier-selection]').textContent=carrier;
    this.querySelector('[data-carrier-price]').textContent='…';
    native.dispatchEvent(new Event('change',{bubbles:true}));
  }
  setText(selector,text){const el=this.querySelector(selector);if(el&&el.textContent!==text)el.textContent=text;}
  sync(){
    const native=this.native();
    if(native){
      const [payment,carrier='Unlocked']=native.value.split(' · ');
      this.select.value=carrier;
      this.payment.value=payment;
      Array.from(this.payment.options).forEach(o=>{o.disabled=carrier!=='Unlocked'&&o.value!=='Pay in Full';});
    }
    const form=document.getElementById(this.dataset.formId);
    const variantId=form?.querySelector('[name="id"]')?.value;
    const variantNode=this.info?.querySelector('variant-selects [data-selected-variant]');
    let selected=null;try{selected=JSON.parse(variantNode?.textContent||'null');}catch{}
    this.setText('[data-carrier-selection]',this.select.value);
    this.setText('[data-carrier-price]',selected?this.prices[String(selected.id)]||'':this.querySelector('[data-unavailable]').content.textContent);
  }
  disconnectedCallback(){this.observer?.disconnect();this.select?.removeEventListener('change',this.onChange);this.payment?.removeEventListener('change',this.onChange);}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-protection-video"] && !Shopify.designMode) return;
  try {
    (() => {
      const instances = new Map();
      const init = (root = document) => {
        root.querySelectorAll('[data-mz-protection-video]').forEach(section => {
          if (instances.has(section)) return;
          const video = section.querySelector('video');
          const sound = section.querySelector('[data-mz-sound-button]');
          const launch = section.querySelector('[data-mz-video-launch]');
          const play = section.querySelector('[data-mz-video-play]');
          const error = section.querySelector('[data-mz-video-error]');
          if (!video || !sound || !launch || !play || !error) return;
          const events = new AbortController();
          const listen = (target, name, callback) => target.addEventListener(name, callback, { signal: events.signal });
          const audible = () => !video.muted && video.volume > 0;
          let started = !video.paused || video.currentTime > 0;
          const sync = () => {
            const on = audible();
            sound.setAttribute('aria-pressed', String(on));
            sound.querySelector('[data-mz-sound-label]').textContent = on ? sound.dataset.soundOn : sound.dataset.soundOff;
            sound.querySelector('[data-mz-sound-icon]').setAttribute('d', on
              ? 'M4 9h4l5-4v14l-5-4H4V9Zm12-1a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14'
              : 'M4 9h4l5-4v14l-5-4H4V9Zm13 0 5 6m0-6-5 6');
            launch.hidden = started;
          };
          const fail = () => {
            if (events.signal.aborted) return;
            error.hidden = false;
            if (video.currentTime === 0 && video.paused) started = false;
            sync();
          };
          listen(play, 'click', () => {
            error.hidden = true;
            video.defaultMuted = false;
            video.muted = false;
            video.volume = 1;
            sync();
            try {
              const result = video.play();
              if (result && typeof result.catch === 'function') result.catch(reason => {
                if (reason?.name !== 'AbortError') fail();
              });
            } catch (exception) { fail(); }
          });
          listen(sound, 'click', () => {
            if (audible()) video.muted = true;
            else {
              video.muted = false;
              if (video.volume === 0) video.volume = 1;
            }
            sync();
          });
          listen(video, 'volumechange', sync);
          listen(video, 'play', () => { started = true; error.hidden = true; sync(); });
          listen(video, 'playing', () => { error.hidden = true; });
          listen(video, 'error', fail);
          listen(video, 'loadedmetadata', sync);
          if (!video.hasAttribute('aria-label')) video.setAttribute('aria-label', section.dataset.videoLabel);
          sound.hidden = false;
          sync();
          instances.set(section, { video, events });
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
      else init();
      document.addEventListener('shopify:section:load', event => init(event.target));
      document.addEventListener('shopify:section:unload', event => {
        instances.forEach((state, section) => {
          if (event.target !== section && !event.target.contains(section)) return;
          state.events.abort();
          state.video.pause();
          instances.delete(section);
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-purchase-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mz-purchase-options'))customElements.define('mz-purchase-options',class extends HTMLElement{
 connectedCallback(){
  if(this.dataset.conditionPricing==='true'){this.initManagedCondition();return;}
  const title=(this.dataset.productTitle||'').toLowerCase();
  const info=this.closest('product-info');
  const isIphone=title.includes('iphone');
  const is16Pro=title.includes('iphone 16 pro')&&!title.includes('pro max');
  const olderBaseOnly=isIphone && (
    title.includes('iphone 7') || title.includes('iphone 8') || title.includes('iphone x') ||
    title.includes('iphone xr') || title.includes('iphone xs') || title.includes('iphone 11') ||
    (title.includes('iphone 12') && !title.includes('12 pro'))
  );
  if(olderBaseOnly){
    const selectors=info?.querySelectorAll('variant-selects .product-form__input')||[];
    selectors.forEach(group=>{
      const label=(group.querySelector('.form__label')?.textContent||'').toLowerCase();
      if(label.includes('storage')){
        const select=group.querySelector('select');
        if(select){
          Array.from(select.options).forEach((o,i)=>{if(i>0)o.hidden=true;});
          select.selectedIndex=0;
          select.dispatchEvent(new Event('change',{bubbles:true}));
        }else{
          const inputs=Array.from(group.querySelectorAll('input'));
          inputs.forEach((el,i)=>{if(i>0){el.hidden=true;const lab=group.querySelector('label[for="'+el.id+'"]');if(lab)lab.hidden=true;}});
          if(inputs[0])inputs[0].click();
        }
      }
      if(title.includes('iphone 7') && label.includes('color')){
        const select=group.querySelector('select');
        if(select){
          let chosen=false;
          Array.from(select.options).forEach(o=>{const ok=/black/i.test(o.value);o.hidden=!ok;if(ok&&!chosen){o.selected=true;chosen=true;}});
          select.dispatchEvent(new Event('change',{bubbles:true}));
        }
      }
    });
  }
  const condition=this.querySelector('[data-mz-condition]');
  if(isIphone && title.replace(/[^a-z0-9]+/g,' ').trim()==='apple iphone 16' && condition){
    const conditionPrices={
      Excellent:{Unlocked:{'128':600,'256':640,'512':680},Locked:{'128':550,'256':590,'512':630}},
      Good:{Unlocked:{'128':550,'256':590,'512':630},Locked:{'128':500,'256':540,'512':590}},
      Fair:{Unlocked:{'128':500,'256':540,'512':590},Locked:{'128':450,'256':490,'512':540}}
    };
    const priceRoot=info?.querySelector('.main__price');
    const money=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:2});
    const selectedValue=(name)=>{const group=Array.from(info?.querySelectorAll('variant-selects .product-form__input')||[]).find(g=>(g.querySelector('.form__label')?.textContent||'').toLowerCase().includes(name));if(!group)return '';const select=group.querySelector('select');if(select)return select.value;return group.querySelector('input:checked')?.value||'';};
    const renderConditionPrice=()=>{if(!priceRoot)return;const storage=(selectedValue('storage').match(/128|256|512/)||[])[0];const carrier=info?.querySelector('mz-phone-carrier [data-mz-phone-carrier]')?.value||'Unlocked';const type=carrier==='Unlocked'?'Unlocked':'Locked';const amount=conditionPrices[condition.value]?.[type]?.[storage];if(amount==null)return;const regular=priceRoot.querySelector('.price-item--regular')||priceRoot.querySelector('.price-item');if(regular)regular.textContent=money.format(amount);priceRoot.dataset.mzConditionPrice=String(amount);};
    condition.addEventListener('change',renderConditionPrice);
    info?.addEventListener('change',()=>requestAnimationFrame(renderConditionPrice));
    info?.querySelector('mz-phone-carrier [data-mz-phone-carrier]')?.addEventListener('change',()=>requestAnimationFrame(renderConditionPrice));
    const observer=new MutationObserver(()=>{if(!priceRoot?.dataset.mzConditionSync){priceRoot.dataset.mzConditionSync='1';requestAnimationFrame(()=>{delete priceRoot.dataset.mzConditionSync;renderConditionPrice();});}});if(priceRoot)observer.observe(priceRoot,{childList:true,subtree:true});requestAnimationFrame(renderConditionPrice);
  }
  this.querySelector('[data-pay-full]')?.addEventListener('click',()=>{
    const root=this.closest('product-info')||document.getElementById('MainContent');
    if(!root)return;
    const groups=Array.from(root.querySelectorAll('variant-selects .product-form__input')).filter(group=>!group.hidden&&group.getClientRects().length>0);
    const storageGroup=groups.find(group=>{
      const name=(group.querySelector('.js-option-name')?.textContent||group.querySelector('.form__label')?.textContent||'').trim();
      return /storage|capacity|memory|\bgb\b|\btb\b/i.test(name);
    });
    const target=storageGroup||groups[0]||root.querySelector('variant-selects')||root.querySelector('product-form');
    if(!target)return;
    const header=document.querySelector('sticky-header')||document.querySelector('.section-header');
    const offset=Math.max(100,Math.min(240,header?.getBoundingClientRect().height||0))+20;
    const top=Math.max(0,target.getBoundingClientRect().top+window.scrollY-offset);
    if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');
    target.focus({preventScroll:true});
    window.scrollTo({top,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  });

  if(is16Pro){
    const condition=this.querySelector('[data-mz-16pro-condition]');
    window.__mz16ProCondition=window.__mz16ProCondition||'Excellent';
    if(condition){
      condition.value=window.__mz16ProCondition;
      condition.addEventListener('change',()=>{
        window.__mz16ProCondition=condition.value;
        this.apply16ProConditionPrice();
      });
    }
    queueMicrotask(()=>this.apply16ProConditionPrice());
    setTimeout(()=>this.apply16ProConditionPrice(),120);
  }
 }
 initManagedCondition(){
  this.managedInfo=this.closest('product-info');
  this.managedCondition=this.querySelector('[data-mz-real-condition]');
  this.managedPayment=this.querySelector('[data-mz-condition-payment]');
  if(!this.managedInfo||!this.managedCondition)return;
  try{this.managedVariants=JSON.parse(this.querySelector('[data-mz-condition-variants]')?.textContent||'[]');}catch{this.managedVariants=[];}
  this.managedConditionLabels=new Map(Array.from(this.managedCondition.options).map(option=>[option.value,option.textContent]));
  try{this.managedMoney=new Intl.NumberFormat(this.dataset.locale||'en',{style:'currency',currency:this.dataset.currency||'USD',minimumFractionDigits:2});}catch{this.managedMoney=new Intl.NumberFormat('en',{style:'currency',currency:'USD',minimumFractionDigits:2});}
  window.__mzConditionSelections=window.__mzConditionSelections||new Map();
  this.managedKey=this.dataset.productId+':'+(this.managedInfo.dataset.section||this.dataset.formId);
  const initial=this.readManagedSelection();
  const mzSaved=window.__mzConditionSelections.get(this.managedKey);
  this.managedState=mzSaved||initial;
  const mzWantExcellent=!mzSaved&&!new URLSearchParams(location.search).get('variant')&&initial.condition!=='Excellent'&&Array.from(this.managedCondition.options).some(option=>option.value==='Excellent');
  if(!Array.from(this.managedCondition.options).some(option=>option.value===this.managedState.condition))this.managedState.condition=initial.condition;
  if(this.managedPayment&&!Array.from(this.managedPayment.options).some(option=>option.value===this.managedState.payment))this.managedState.payment=initial.payment;
  this.managedCondition.value=this.managedState.condition;
  if(this.managedPayment)this.managedPayment.value=this.managedState.payment;
  this.managedOnCustomChange=()=>{
    this.managedState={condition:this.managedCondition.value,payment:this.managedPayment?.value||'Pay in Full'};
    window.__mzConditionSelections.set(this.managedKey,{...this.managedState});
    this.chooseManagedVariant();
  };
  this.managedCondition.addEventListener('change',this.managedOnCustomChange);
  this.managedPayment?.addEventListener('change',this.managedOnCustomChange);
  this.managedOnNativeChange=event=>{
    if(!event.target.closest('variant-selects'))return;
    this.managedPending=true;
    this.managedInfo.productForm?.toggleSubmitButton(true);
    this.updateManagedConditionPrices();
  };
  this.managedInfo.addEventListener('change',this.managedOnNativeChange,true);
  this.managedOnSubmit=event=>{
    if(this.managedReady())return;
    event.preventDefault();
    event.stopImmediatePropagation();
    this.managedInfo.productForm?.toggleSubmitButton(true);
  };
  this.managedInfo.addEventListener('submit',this.managedOnSubmit,true);
  this.managedObserver=new MutationObserver(()=>this.syncManagedSelection());
  this.managedObserver.observe(this.managedInfo,{childList:true,subtree:true});
  this.querySelector('[data-pay-full]')?.addEventListener('click',()=>{
    if(this.managedPayment&&Array.from(this.managedPayment.options).some(option=>option.value==='Pay in Full')){
      this.managedPayment.value='Pay in Full';
      this.managedOnCustomChange();
    }
    const target=Array.from(this.managedInfo.querySelectorAll('variant-selects .product-form__input')).find(group=>!group.hidden&&group.getClientRects().length>0)||this.managedCondition;
    if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');
    target.focus({preventScroll:true});
    target.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  });
  this.syncManagedSelection();
  if(mzWantExcellent){
    const mzGo=()=>{const mzCur=window.__mzConditionSelections.get(this.managedKey);if(!this.isConnected||(mzCur&&mzCur.condition!==initial.condition)||this.managedCondition.value!==initial.condition)return;this.managedCondition.value='Excellent';this.managedOnCustomChange();};
    if(document.readyState==='complete')setTimeout(mzGo,300);else window.addEventListener('load',()=>setTimeout(mzGo,300),{once:true});
  }
 }
 managedNative(name){return Array.from(this.managedInfo?.querySelectorAll('variant-selects [data-mz-condition-native]')||[]).find(select=>select.dataset.mzConditionNative===name);}
 readManagedSelection(){
  const purchase=this.managedNative('Purchase Type')?.value||'Pay in Full';
  const parts=purchase.split(' | ');
  return {condition:this.managedNative('Condition')?.value||parts[1]||'Good',payment:parts[0]||'Pay in Full'};
 }
 managedPurchaseValue(){
  if(this.managedNative('Condition'))return this.managedState.payment;
  return this.managedState.payment+(this.managedState.condition==='Good'?'':' | '+this.managedState.condition);
 }
 chooseManagedVariant(){
  const changes=[];
  const condition=this.managedNative('Condition');
  const purchase=this.managedNative('Purchase Type');
  const choices=[[condition,this.managedState.condition],[purchase,this.managedPurchaseValue()]];
  for(const [select,value] of choices){
    if(!select)continue;
    if(!Array.from(select.options).some(option=>option.value===value)){
      this.managedPending=true;
      this.managedInfo.productForm?.toggleSubmitButton(true,window.variantStrings?.unavailable);
      return;
    }
    if(select.value!==value){
      select.value=value;
      const chosen=select.selectedOptions[0];
      Array.from(select.options).forEach(option=>{if(option===chosen)option.setAttribute('selected','selected');else option.removeAttribute('selected');});
      changes.push(select);
    }
  }
  if(changes.length){
    this.managedPending=true;
    this.managedInfo.productForm?.toggleSubmitButton(true);
    changes[changes.length-1].dispatchEvent(new Event('change',{bubbles:true}));
  }else this.syncManagedSelection();
 }
 managedReady(){
  const picker=this.managedInfo?.querySelector('variant-selects');
  let variant=null;
  try{variant=JSON.parse(picker?.querySelector('[data-selected-variant]')?.textContent||'null');}catch{}
  const selection=this.readManagedSelection();
  const values=Array.from(picker?.querySelectorAll('.product-form__input')||[]).map(group=>group.querySelector('select')?.value||group.querySelector('input:checked')?.value);
  const id=document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value;
  return Boolean(variant&&variant.available&&String(variant.id)===String(id)&&selection.condition===this.managedState.condition&&selection.payment===this.managedState.payment&&values.length===variant.options?.length&&values.every((value,index)=>value===variant.options[index]));
 }
 updateManagedConditionPrices(){
  if(!this.managedVariants?.length)return;
  const groups=Array.from(this.managedInfo.querySelector('variant-selects')?.querySelectorAll('.product-form__input')||[]);
  const values=groups.map(group=>group.querySelector('select')?.value||group.querySelector('input:checked')?.value);
  const conditionIndex=groups.findIndex(group=>group.querySelector('[data-mz-condition-native="Condition"]'));
  const purchaseIndex=groups.findIndex(group=>group.querySelector('[data-mz-condition-native="Purchase Type"]'));
  for(const option of this.managedCondition.options){
    const desired=values.slice();
    if(conditionIndex>=0)desired[conditionIndex]=option.value;
    if(purchaseIndex>=0)desired[purchaseIndex]='Pay in Full'+(conditionIndex>=0||option.value==='Good'?'':' | '+option.value);
    const variant=this.managedVariants.find(candidate=>candidate.options?.length===desired.length&&candidate.options.every((value,index)=>value===desired[index]));
    const label=this.managedConditionLabels.get(option.value)||option.value;
    const text=variant?label+' - '+this.managedMoney.format(variant.price/100):label;
    if(option.textContent!==text)option.textContent=text;
  }
 }
 syncManagedSelection(){
  if(!this.isConnected||!this.managedInfo)return;
  const picker=this.managedInfo.querySelector('variant-selects');
  if(!picker)return;
  const selection=this.readManagedSelection();
  const condition=this.managedNative('Condition');
  const purchase=this.managedNative('Purchase Type');
  this.updateManagedConditionPrices();
  if((selection.condition!==this.managedState.condition||selection.payment!==this.managedState.payment)&&this.managedRestoredPicker!==picker){
    this.managedRestoredPicker=picker;
    this.chooseManagedVariant();
    return;
  }
  this.managedCondition.value=this.managedState.condition;
  if(this.managedPayment)this.managedPayment.value=this.managedState.payment;
  if(this.managedPayment){
    Array.from(this.managedPayment.options).forEach(option=>{
      const value=condition?option.value:option.value+(this.managedState.condition==='Good'?'':' | '+this.managedState.condition);
      option.disabled=!Array.from(purchase?.options||[]).some(nativeOption=>nativeOption.value===value);
    });
  }
  if(this.managedReady()){
    this.managedPending=false;
    window.__mzConditionSelections.set(this.managedKey,{...this.managedState});
  }else this.managedInfo.productForm?.toggleSubmitButton(true);
 }
 disconnectedCallback(){
  this.managedObserver?.disconnect();
  this.managedInfo?.removeEventListener('change',this.managedOnNativeChange,true);
  this.managedInfo?.removeEventListener('submit',this.managedOnSubmit,true);
  this.managedCondition?.removeEventListener('change',this.managedOnCustomChange);
  this.managedPayment?.removeEventListener('change',this.managedOnCustomChange);
 }
 apply16ProConditionPrice(){
  const info=this.closest('product-info');
  if(!info)return;
  const condition=this.querySelector('[data-mz-16pro-condition]')?.value||window.__mz16ProCondition||'Excellent';
  let selected=null;
  try{selected=JSON.parse(info.querySelector('variant-selects [data-selected-variant]')?.textContent||'null');}catch{}
  if(!selected)return;
  const storage=selected.options?.[0]||'';
  const purchase=selected.options?.[2]||'';
  const locked=purchase.includes(' · ');
  const matrix={
    Excellent:{Unlocked:{'256GB':800,'512GB':860,'1TB':920},Locked:{'256GB':750,'512GB':810,'1TB':870}},
    Good:{Unlocked:{'256GB':720,'512GB':780,'1TB':840},Locked:{'256GB':640,'512GB':730,'1TB':790}},
    Fair:{Unlocked:{'256GB':640,'512GB':780,'1TB':760},Locked:{'256GB':670,'512GB':650,'1TB':710}}
  };
  const price=matrix[condition]?.[locked?'Locked':'Unlocked']?.[storage];
  if(price==null)return;
  const money=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:2}).format(price);
  const priceRoot=info.querySelector('[id^="price-"]')||info;
  const regular=priceRoot.querySelector('.price__regular .price-item--regular');
  const sale=priceRoot.querySelector('.price__sale .price-item--sale');
  if(regular)regular.textContent=money;
  if(sale)sale.textContent=money;
  const carrierPrice=info.querySelector('[data-carrier-price]');
  if(carrierPrice)carrierPrice.textContent=money;
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-scroll-background"] && !Shopify.designMode) return;
  try {
    (() => {
    function init() {
      if (!document.body.classList.contains('page-index')) return;
      const main = document.getElementById('MainContent');
      if (!main || main.dataset.mzAmbientReady) return;
      main.dataset.mzAmbientReady = 'v2';
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const hosts = new Map();
      const active = new Set();
      let frame = 0;
      function draw() {
        frame = 0;
        if (document.hidden || motion.matches) return;
        const viewport = window.innerHeight;
        const updates = [];
        for (const host of active) {
          if (!host.isConnected) continue;
          const rect = host.getBoundingClientRect();
          const progress = Math.max(-1, Math.min(1, (viewport - 2 * rect.top - rect.height) / (viewport + rect.height)));
          updates.push([hosts.get(host), progress.toFixed(4)]);
        }
        for (const [layer, progress] of updates) layer.style.setProperty('--mz-progress', progress);
      }
      function schedule() {
        if (!frame && !document.hidden && !motion.matches) frame = requestAnimationFrame(draw);
      }
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            active.add(entry.target);
            entry.target.classList.add('mz-ambient-visible');
          } else active.delete(entry.target);
        }
        schedule();
      }, { rootMargin: '80px 0px', threshold: 0 }) : null;
      function setup() {
        for (const [host] of hosts) {
          if (host.isConnected) continue;
          observer?.unobserve(host);
          active.delete(host);
          hosts.delete(host);
        }
        const targets = [...main.querySelectorAll('.mz-hero, #mz-video-slider, .cr-google-reviews')];
        for (const section of main.querySelectorAll(':scope > .shopify-section')) {
          if (!/__(collection_list_|featured_collection_|collage_banner_|text_with_icons_|featured_blog_)/.test(section.id)) continue;
          const surface = section.querySelector(':scope > .gradient');
          if (surface) targets.push(surface);
        }
        targets.forEach((host, index) => {
          if (hosts.has(host)) return;
          const layer = document.createElement('div');
          layer.className = 'mz-ambient' + (index % 2 ? ' mz-ambient--reverse' : '');
          layer.setAttribute('aria-hidden', 'true');
          for (const part of ['glow mz-ambient__glow--blue', 'glow mz-ambient__glow--violet', 'orbit']) {
            const decoration = document.createElement('span');
            decoration.className = 'mz-ambient__' + part;
            layer.appendChild(decoration);
          }
          host.classList.add('mz-ambient-host');
          host.prepend(layer);
          hosts.set(host, layer);
          if (observer) observer.observe(host);
          else { active.add(host); host.classList.add('mz-ambient-visible'); }
        });
        schedule();
      }
      setup();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      document.addEventListener('visibilitychange', schedule);
      document.addEventListener('shopify:section:load', setup);
      motion.addEventListener('change', () => {
        if (frame) cancelAnimationFrame(frame);
        frame = 0;
        if (motion.matches) hosts.forEach(layer => layer.style.removeProperty('--mz-progress'));
        else schedule();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-trust-cards"] && !Shopify.designMode) return;
  try {
    (() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  const syncVisibility = () => instances.forEach((state, section) => {
    section.toggleAttribute('data-hidden', document.hidden);
  });
  const syncMotion = () => instances.forEach(state => {
    state.toggle.hidden = motion.matches;
    if (motion.matches) state.entrances.forEach(animation => animation.cancel());
  });
  const init = (scope = document) => {
    scope.querySelectorAll('[data-mz-trust]').forEach(section => {
      if (instances.has(section)) return;
      const toggle = section.querySelector('[data-mz-trust-toggle]');
      const abort = new AbortController();
      const entrances = [];
      const items = [...section.querySelectorAll('.mz-trust__item')];
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          item.classList.toggle('is-visible', entry.isIntersecting);
          if (entry.isIntersecting && !item.dataset.entered) {
            item.dataset.entered = 'true';
            if (!motion.matches && !section.hasAttribute('data-paused')) {
              entrances.push(item.animate([
                { opacity: .3, transform: 'translateY(24px)' },
                { opacity: 1, transform: 'translateY(0)' }
              ], { duration: 700, delay: items.indexOf(item) * 65, easing: 'cubic-bezier(.2,.75,.3,1)' }));
            }
          }
        });
      }, { threshold: .05 });
      items.forEach(item => observer.observe(item));
      toggle.addEventListener('click', () => {
        const paused = section.toggleAttribute('data-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.querySelector('span').textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        toggle.querySelector('path').setAttribute('d', paused ? 'M6 4l9 6-9 6Z' : 'M7 5v10M13 5v10');
        if (paused) entrances.forEach(animation => animation.cancel());
      }, { signal: abort.signal });
      section.setAttribute('data-ready', '');
      toggle.hidden = motion.matches;
      instances.set(section, { observer, abort, entrances, toggle });
    });
    syncVisibility();
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((state, section) => {
      if (!event.target.contains(section)) return;
      state.observer.disconnect();
      state.abort.abort();
      state.entrances.forEach(animation => animation.cancel());
      instances.delete(section);
    });
  });
  document.addEventListener('visibilitychange', syncVisibility);
  motion.addEventListener('change', syncMotion);
})();
  } catch(e) { console.error(e); }
})();

})();
